module.exports = __webpack_public_path__ + "img/package-return-nonactive.1e16aa65.png";